import React, {useState} from 'react';
import UserManager, {useUserData} from "../../../managers/userManager/userManager";
import AddressShowBox from "../../../checkout/components/shipping/AddressShowBox";
import {validateUserInfo, validateUserInfoItem} from "../../../managers/cartManager/validators/userInfoValidator";
import {ClearOutlined, DeleteOutline, EditOutlined} from "@mui/icons-material";
import {CardContent, Modal, Paper} from "@mui/material";
import DataForm from "../../../checkout/components/billingData/DataForm";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {Trans} from "react-i18next";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import UserInfoContract from "../../../managers/cartManager/contracts/userInfoContract";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

const newKey = 'new';

function MyAddresses() {
    const userData = useUserData();
    const [openedKey, setOpenedKey] = useState('');
    const [removeKey, setRemoveKey] = useState('');
    const [openedAddress, setOpenedAddress] = useState({});
    const [dataFormValidity, setDataFormValidity] = useState({});

    const onDataFormChange = (id, value) => {
        const newOpenedAddress = {...openedAddress};
        setDataFormItemValidity(id, validateUserInfoItem(id, value));
        newOpenedAddress[id] = value;
        setOpenedAddress(newOpenedAddress);
    }

    const checkFormValidity = () => {
        const validity = validateUserInfo(openedAddress, {email: true})
        setDataFormValidity(validity);
        return Object.keys(validity).length === 0;
    }

    const onDataFormBlur = (id) => {
        setDataFormItemValidity(id, validateUserInfoItem(id, openedAddress[id]));
    }

    const setDataFormItemValidity = (id, error) => {
        const newValidity = Object.assign({}, dataFormValidity);
        newValidity[id] = error;
        setDataFormValidity(newValidity);
    }

    const getControls = (key) => {
        return (<>
            <EditOutlined sx={{cursor: 'pointer', color: 'text.secondary'}} onClick={() => openEditModal(key)}/>
            <DeleteOutline sx={{cursor: 'pointer', color: 'text.secondary'}} onClick={() => openRemoveModal(key)}/>
        </>);
    }

    const removeAddress = () => {
        UserManager.deleteAddressFromSavedAdresses(removeKey);
        closeRemoveModal();
    }

    const openEditModal = (key) => {
        if (key === newKey) {
            setOpenedAddress(new UserInfoContract());
        } else {
            setOpenedAddress({...userData?.savedAddresses?.[key]});
        }

        setOpenedKey(key);
    }

    const closeEditModal = () => {
        setOpenedKey('');
        setOpenedAddress({});
    }

    const openRemoveModal = (key) => {
        setRemoveKey(key);
    }

    const closeRemoveModal = () => {
        setRemoveKey('');
    }

    const handleSubmit = () => {
        const valid = checkFormValidity();
        if (valid) {
            if (openedKey === newKey) {
                UserManager.addNewAddressToSavedAdresses(openedAddress);
            } else {
                UserManager.setSavedAddress(openedAddress, openedKey);
            }
            closeEditModal();
        }
    }

    return (userData?.savedAddresses &&
        <div className="myaddresses">
            {Object.keys(userData.savedAddresses || {}).filter(key => userData.savedAddresses?.[key]).map(key =>
                <AddressShowBox key={key} address={userData.savedAddresses?.[key]}
                                rightTopCornerBoxContent={getControls(key)}/>)}
            <Box sx={{justifyContent: 'center', alignItems: 'center', display: 'flex', pt: 3, maxWidth: 400}}>
                <AddCircleIcon fontSize={'large'} sx={{color: 'text.secondary', cursor: 'pointer'}}
                               onClick={() => openEditModal(newKey)}/>
            </Box>
            <Modal
                open={Boolean(openedKey)}
                onClose={closeEditModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            >
                <Paper sx={{width: {xs: '100%', sm: 500}, maxHeight: '100%', overflowY: 'auto', overflowX: 'hidden'}}>
                    <IconButton onClick={closeEditModal}
                                sx={{position: 'absolute', top: -5, right: -5, zIndex: 100}}>
                        <ClearOutlined/>
                    </IconButton>
                    <CardContent>
                        <DataForm userInfo={openedAddress} onChange={onDataFormChange} validity={dataFormValidity}
                                  onBlur={onDataFormBlur} withoutEmail={true}/>
                        <Box sx={{justifyContent: 'flex-end', alignItems: 'center', display: 'flex', pt: 3}}>
                            <Button variant={'contained'} onClick={handleSubmit}>
                                <Trans i18nKey={'buttons.submit'}/>
                            </Button>
                        </Box>
                    </CardContent>
                </Paper>
            </Modal>
            <Modal
                open={Boolean(removeKey)}
                onClose={closeRemoveModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            >
                <Paper sx={{width: {xs: '100%', sm: 500}}}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            <Trans i18nKey="deleteConfirmation.title">
                                Are you sure you want to delete this item?
                            </Trans>
                        </Typography>
                        <AddressShowBox key={removeKey} address={userData.savedAddresses?.[removeKey] || {}}/>
                        <Typography variant="body2" color="textSecondary">
                            <Trans i18nKey="deleteConfirmation.message">
                                This action cannot be undone. Please confirm if you'd like to proceed.
                            </Trans>
                        </Typography>
                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Button onClick={closeRemoveModal} variant="outlined" color="secondary"
                                    sx={{marginRight: 1}}>
                                <Trans i18nKey="buttons.cancel">Cancel</Trans>
                            </Button>
                            <Button onClick={removeAddress} variant="contained" color="primary">
                                <Trans i18nKey="buttons.delete">Delete</Trans>
                            </Button>
                        </div>
                    </CardContent>
                </Paper>
            </Modal>
        </div>
    );
}

export default MyAddresses;
